<template>
  <v-container id="exam-edit" grid-list-md fluid>
    <v-form ref="formExam" v-model="validForm" lazy-validation>
      <!-- fluid  -->
      <!-- fill-height -->
      <v-layout row wrap>
        <!-- justify-center -->
        <!-- align-center -->
        <v-flex md4 sm12 text-xs-center
          ><!-- Datos Paciente -->
          <v-card id="personal_data" class="pa-2">
            <v-btn
              color="accent"
              @click="modEditPerson = !modEditPerson"
              :outline="modEditPerson"
              right
              small
              fab
            >
              <v-icon>edit</v-icon>
            </v-btn>

            <v-flex xs12
              ><!-- IDPaciente -->
              <v-text-field
                v-model="IDpaciente"
                :rules="rutRules"
                prepend-icon="credit_card"
                label="ID Paciente"
                type="text"
                :background-color="modEditPerson ? 'tertiary' : ''"
                color="primary"
                :disabled="!modEditPerson"
                @blur="IDpaciente = formatRut(IDpaciente)"
                box
              ></v-text-field>
            </v-flex>
            <v-flex xs12
              ><!-- nombre_paciente -->
              <v-text-field
                v-model="nombre_paciente"
                :rules="requireRules"
                prepend-icon="person"
                label="Nombre Paciente"
                type="text"
                :background-color="modEditPerson ? 'tertiary' : ''"
                color="primary"
                :disabled="!modEditPerson"
                box
              ></v-text-field>
            </v-flex>
            <v-flex xs12
              ><!-- sexo_paciente -->
              <v-combobox
                v-model="sexo_paciente"
                :rules="requireRules"
                :items="selectSexos"
                label="Sexo paciente"
                prepend-icon="sentiment_satisfied_alt"
                :background-color="modEditPerson ? 'tertiary' : ''"
                color="primary"
                :disabled="!modEditPerson"
                box
              ></v-combobox>
            </v-flex>
            <v-flex xs12
              ><!-- fechaNac_paciente -->
              <v-menu
                ref="menuFechaNac"
                v-model="menuFechaNac"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                max-width="290px"
                min-width="290px"
                full-width
                lazy
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fechaNac_paciente"
                    :rules="requireRules"
                    label="Fecha naciemiento paciente"
                    hint="DD/MM/YYYY"
                    persistent-hint
                    prepend-icon="event"
                    :background-color="modEditPerson ? 'tertiary' : ''"
                    color="primary"
                    @blur="selectDateNacPaciente = parseDate(fechaNac_paciente)"
                    @click="
                      selectDateNacPaciente = parseDate(fechaNac_paciente)
                    "
                    :disabled="!modEditPerson"
                    v-on="on"
                    box
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectDateNacPaciente"
                  @input="menuFechaNac = false"
                  first-day-of-week="1"
                  locale="es-cl"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12
              ><!-- edad_paciente -->
              <v-text-field
                v-model="edad_paciente"
                prepend-icon="cake"
                label="Edad Paciente"
                type="text"
                color="primary"
                :disabled="true"
                box
              ></v-text-field>
            </v-flex>
            <v-flex xs12
              ><!-- correo_paciente -->
              <v-text-field
                v-model="correo_paciente"
                :rules="emailRules"
                prepend-icon="mail"
                label="Correo Paciente"
                type="text"
                :background-color="modEditPerson ? 'tertiary' : ''"
                color="primary"
                :disabled="!modEditPerson"
                box
              ></v-text-field>
            </v-flex>
            <v-flex xs12
              ><!-- antecedentes_clinicos -->
              <v-textarea
                v-model="antecedentes_clinicos"
                prepend-icon="assignment_ind"
                label="Antecedentes clínicos"
                :background-color="modEditPerson ? 'tertiary' : ''"
                color="primary"
                :disabled="!modEditPerson"
                box
              ></v-textarea>
            </v-flex>
          </v-card>
        </v-flex>

        <v-flex md8 sm12
          ><!-- Datos Examen -->
          <v-card class="pa-2">
            <v-flex xs12
              ><!-- modalidad -->
              <v-combobox
                v-model="modalidad"
                :rules="requireRules"
                :items="selectModalidades"
                item-text="sigla"
                item-value="id_modalidad"
                label="Seleccione la modalidad"
                prepend-icon="dns"
                background-color="tertiary"
                color="primary"
                return-object
                clearable
                box
                @change="getPrestaciones"
              ></v-combobox>
            </v-flex>
            <v-flex xs12
              ><!-- prestaciones -->
              <v-combobox
                v-model="prestaciones"
                :rules="requireRules"
                :items="selectPrestaciones"
                item-text="nombre_prestacion"
                item-value="id_prestacion"
                label="Seleccione la(s) prestacion(es)"
                prepend-icon="check_box"
                background-color="tertiary"
                color="primary"
                :disabled="!modalidad"
                return-object
                clearable
                multiple
                chips
                box
              ></v-combobox>
            </v-flex>
            <v-flex xs12
              ><!-- fecha_hora_examen -->
              <v-menu
                ref="menuFechaExa"
                v-model="menuFechaExa"
                :rules="requireRules"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                max-width="290px"
                min-width="290px"
                full-width
                lazy
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha_hora_examen"
                    label="Fecha examen"
                    hint="DD/MM/YYYY"
                    persistent-hint
                    prepend-icon="event"
                    background-color="tertiary"
                    color="primary"
                    @click="selectDateExamen = parseDate(fecha_hora_examen)"
                    v-on="on"
                    box
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectDateExamen"
                  @input="menuFechaExa = false"
                  first-day-of-week="1"
                  locale="es-cl"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 medico_solicitante
              ><!-- medico_solicitante -->
              <v-combobox
                v-model="medico_solicitante"
                :items="selectSolicitantes"
                item-text="nombre_completo_solicitante"
                item-value="id_solicitante"
                :label="label_solicitante"
                prepend-icon="local_hospital"
                background-color="tertiary"
                color="primary"
                :hint="correo_solicitante"
                persistent-hint
                return-object
                @change="debug"
                clearable
                box
              >
                <template slot="append-outer" class="addSolicitante">
                  <v-btn
                    color="accent"
                    @click="dialogApplicant = !dialogApplicant"
                    small
                    fab
                  >
                    <v-icon>person_add</v-icon>
                  </v-btn>
                  <!-- <v-icon @click="addSolicitante">person_add</v-icon> -->
                </template>
              </v-combobox>
              <v-dialog v-model="dialogApplicant" fullscreen persistent>
                <v-card>
                  <v-form
                    ref="formApplicant"
                    v-model="validForm"
                    lazy-validation
                  >
                    <v-card-title class="primary white--text">
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md6>
                            <v-text-field
                              v-model="editedItem.nombre_solicitante"
                              label="Nombre Odontólogo"
                              background-color="tertiary"
                              color="primary"
                              :rules="requireRules"
                              autofocus
                              box
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-text-field
                              v-model="editedItem.apellido_solicitante"
                              label="Apellidos Odontólogo"
                              background-color="tertiary"
                              color="primary"
                              :rules="requireRules"
                              box
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field
                              v-model="editedItem.correo_solicitante"
                              label="Correo Odontólogo"
                              background-color="tertiary"
                              color="primary"
                              :rules="emailRules"
                              box
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray darken-1" flat @click="closeApplicant"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        color="primary darken-1"
                        @click="saveApplicant"
                        :disabled="!validForm"
                        :loading="loading"
                        >Guardar</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
              <!-- item-text="correo_solicitante -->
              <!-- :item-text="(el) => el.nombre_completo_solicitante +' ('+ el.correo_solicitante+')'" -->
              <!-- @change="getPrestaciones" -->
            </v-flex>
            <v-flex xs12
              ><!-- medico_informante -->
              <v-combobox
                v-model="medico_informante"
                :rules="requireRules"
                :items="selectInformantes"
                return
                item-text="nombre_completo"
                item-value="id_usuario"
                :label="label_informante"
                prepend-icon="record_voice_over"
                background-color="tertiary"
                color="primary"
                return-object
                clearable
                box
              ></v-combobox>
              <!-- @change="getPrestaciones" -->
            </v-flex>
            <v-flex xs12
              ><!-- comentario_tm -->
              <v-textarea
                box
                v-model="comentario_tm"
                label="Comentario TM"
                prepend-icon="assignment"
                background-color="tertiary"
                color="primary"
              ></v-textarea>
            </v-flex>
            <v-flex xs12
              ><!-- scanner -->
              <v-bottom-sheet v-model="ordenSheet" class="ml-4">
                <template v-slot:activator>
                  <v-btn color="accent" dark fab small title="Cargar Orden">
                    <v-icon dark>cloud_upload</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-subheader>Cargar desde</v-subheader>
                  <v-list-tile @click="scanImg">
                    <v-list-tile-avatar>
                      <v-avatar size="32px" tile>
                        <v-icon>scanner</v-icon>
                      </v-avatar>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Escáner</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="attachImg">
                    <v-list-tile-avatar>
                      <v-avatar size="32px" tile>
                        <v-icon>attachment</v-icon>
                      </v-avatar>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Adjuntar</v-list-tile-title>
                    <v-list-tile-content>
                      <input
                        type="file"
                        style="display: none"
                        ref="attachmentOrden"
                        accept="image/*"
                        @change="onAttachSelectOrden"
                      />
                      <!-- multiple -->
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-bottom-sheet>
              <!-- <small v-if="orden_medica.length > 0">{{ orden_medica.reduce((last, current, index) => { return last.name +', '+ current.name } ) }}</small> -->
              <div class="dwtcontrolContainer" :class="{ hidden: !haveScann }">
                <div id="dwtcontrolContainer"></div>
              </div>
              <small v-if="orden_medica">{{
                (filesExam.orden.length > 0 ? "Reemplazando: " : "Cargando: ") +
                  orden_medica.name
              }}</small>
              <small v-else-if="filesExam.orden.length > 0">
                Orden cargada ({{ filesExam.orden.length }}):
                <template v-for="(orden, index, key) in filesExam.orden">
                  <span :key="key">
                    <v-btn
                      outline
                      small
                      flat
                      @click="viewImage(filesExam.orden)"
                      class="mr-0 pr-0"
                      >{{ orden.nomArchivo }}
                      <v-btn
                        flat
                        icon
                        color="pink"
                        @click.stop="deleteFile(orden)"
                        class="mx-0"
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                    </v-btn>
                  </span>
                </template>
              </small>
              <small v-else-if="!haveScann">No hay orden cargada.</small>
            </v-flex>
            <v-flex xs12
              ><!-- dcm -->
              <div class="ml-4">
                <v-btn
                  color="accent"
                  dark
                  fab
                  small
                  class="mx-2"
                  @click="attachDcm"
                  title="Cargar DCM"
                >
                  <v-icon dark>cloud_upload</v-icon>
                </v-btn>
                <input
                  type="file"
                  style="display: none"
                  ref="attachmentDcm"
                  @change="onAttachSelectDcm"
                  multiple
                />

                <small v-if="filesExam.otrodcm.length > 0">
                  DCM cargados ({{ filesExam.otrodcm.length }}):
                  <template v-for="(otrodcm, index, key) in filesExam.otrodcm">
                    <span :key="key">
                      <v-btn
                        outline
                        small
                        flat
                        @click.stop="downloadFile(otrodcm)"
                        class="mr-0 pr-0"
                        >{{ otrodcm.nomArchivo }}
                        <v-btn
                          flat
                          icon
                          color="pink"
                          @click.stop="deleteFile(otrodcm)"
                          class="mx-0"
                        >
                          <v-icon>delete_forever</v-icon>
                        </v-btn>
                      </v-btn>
                    </span>
                  </template>
                </small>

                <small v-if="dcm.length > 0">{{
                  (filesExam.otrodcm.length > 0 ? "Cargando: " : "Cargando: ") +
                    dcms
                }}</small>

                <small v-if="dcm.length == 0 && filesExam.otrodcm.length == 0"
                  >No hay DCM cargado.</small
                >
              </div>
            </v-flex>
            <v-flex xs12
              ><!-- fotografias y modelos -->
              <div class="ml-4">
                <v-btn
                  color="accent"
                  dark
                  fab
                  small
                  class="mx-2"
                  @click="attachMod"
                  title="Cargar Fotos y Modelos"
                >
                  <v-icon dark>cloud_upload</v-icon>
                </v-btn>
                <input
                  type="file"
                  style="display: none"
                  ref="attachmentMod"
                  @change="onAttachSelectMod"
                  multiple
                />
                <small v-if="mod.length > 0">{{
                  (filesExam.mod.length > 0 ? "Reemplazando: " : "Cargando: ") +
                    mods
                }}</small>
                <small v-else-if="filesExam.mod.length > 0">
                  FyM cargados ({{ filesExam.mod.length }}):
                  <template v-for="(mod, index, key) in filesExam.mod">
                    <span :key="key">
                      <v-btn
                        outline
                        small
                        flat
                        @click.stop="downloadFile(mod)"
                        class="mr-0 pr-0"
                        >{{ mod.nomArchivo }}
                        <v-btn
                          flat
                          icon
                          color="pink"
                          @click.stop="deleteFile(mod)"
                          class="mx-0"
                        >
                          <v-icon>delete_forever</v-icon>
                        </v-btn>
                      </v-btn>
                    </span>
                  </template>
                </small>
                <small v-else>No hay fotografías ni modelos cargados.</small>
              </div>
            </v-flex>
            <v-flex xs12
              ><!-- modelos stl -->
              <div class="ml-4">
                <v-btn
                  color="accent"
                  dark
                  fab
                  small
                  class="mx-2"
                  @click="attachStl"
                  title="Cargar Modelos STL"
                >
                  <v-icon dark>cloud_upload</v-icon>
                </v-btn>
                <input
                  type="file"
                  style="display: none"
                  ref="attachmentStl"
                  accept=".stl"
                  @change="onAttachSelectStl"
                  multiple
                />
                <small v-if="stl.length > 0">{{
                  (filesExam.stl.length > 0 ? "Reemplazando: " : "Cargando: ") +
                    stls
                }}</small>
                <small v-else-if="filesExam.stl.length > 0">
                  STL cargados ({{ filesExam.stl.length }}):
                  <template v-for="(stl, index, key) in filesExam.stl">
                    <span :key="key">
                      <v-btn
                        outline
                        small
                        flat
                        @click.stop="downloadFile(stl)"
                        class="mr-0 pr-0"
                        >{{ stl.nomArchivo }}
                        <v-btn
                          flat
                          icon
                          color="pink"
                          @click.stop="deleteFile(stl)"
                          class="mx-0"
                        >
                          <v-icon>delete_forever</v-icon>
                        </v-btn>
                      </v-btn>
                    </span>
                  </template>
                </small>
                <small v-else>No hay STL cargados.</small>
              </div>
            </v-flex>

            <!-- <v-btn flat small disabled @click="scanToJpg">Cargar Orden</v-btn> -->
            <!-- <v-overflow-btn
              :items="dropdown_orden"
              label="Cargar Orden"
              target="#exam-edit"
              @change="upOrden"
            ></v-overflow-btn> -->

            <!-- <v-btn flat small disabled>Cargar Anexo</v-btn> -->
            <!-- <template>
              <v-layout>
                <v-flex xs12 sm6 offset-sm3>
                  <v-card>
                    <v-container grid-list-sm fluid>
                      <v-layout row wrap>
                        <v-flex
                          v-for="n in orden_medica"
                          :key="n"
                          xs4
                          d-flex
                        >
                          <v-card flat tile class="d-flex">
                            <v-img
                              :src="n.src"
                              :lazy-src="n.src"
                              aspect-ratio="1"
                              class="grey lighten-2"
                            >
                              <template v-slot:placeholder>
                                <v-layout
                                  fill-height
                                  align-center
                                  justify-center
                                  ma-0
                                >
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-layout>
                              </template>
                            </v-img>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </template> -->
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12
          ><!-- acciones -->
          <v-btn depressed :to="{ name: 'Exams' }">Volver</v-btn>
          <v-btn
            color="primary"
            @click="saveData"
            :loading="loading"
            :disabled="!validForm"
            >Guardar</v-btn
          >
          <!-- <v-btn @click="saveScan">Guardar Scanner</v-btn> -->
        </v-flex>
      </v-layout>

      <template
        ><!-- viewer -->
        <v-container d-none grid-list-sm fluid>
          <v-layout
            row
            wrap
            v-viewer="viewerOptions"
            class="viewer"
            ref="viewer"
          >
            <figure v-for="(image, index) in images" :key="index">
              <img
                class="responsive-img"
                :src="image.url"
                :data-source="image.url"
                alt="Imagen DCM"
                width="200"
              />
            </figure>
          </v-layout>
        </v-container>
      </template>

      <v-snackbar
        v-model="snack"
        :timeout="snackTime || 3000"
        :color="snackColor"
      >
        {{ snackText }}
        <v-btn flat @click="snack = false">Cerrar</v-btn>
      </v-snackbar>
    </v-form>
  </v-container>
</template>

<style lang="scss" scope>
.v-icon {
  &.theme--dark {
    color: var(--v-primary-color);
  }
}
.dwtcontrolContainer {
  // display: none;
  display: inline-flex;
  width: 100px;
  &.hidden {
    // visibility: hidden;
    display: none;
  }
}
.medico_solicitante .v-input__append-outer {
  margin: 0px !important;
}
</style>

<script>
import axios from "axios";
import { bus } from "./../main";
import { validaRut, formatRut } from "./../plugins/Rut";
import { setTimeout } from "timers";
var moment = require("moment");
// import scanner from "scannerjs"
//import { configBaseAxios } from "./../plugins/configBaseAxios";
var configBaseAxios = {
  timeout: 10000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "x-www-form-urlencoded",
  },
  params: {},
};
export default {
  mounted() {
    // console.log('mounted')
    this.logged_user = JSON.parse(localStorage.getItem("logged_user"));

    if (!this.logged_user) {
      bus.$emit("userStatus", {
        isLogged: false,
        message: "Sesión de usuario finalizada",
      });
    }

    if (this.logged_user.id_perfil == 4) {
      this.$router.push({ name: "Find" });
    }
    this.init();
  },
  data: (vm) => ({
    pagename: "Editar Examen",
    logged_user: null,
    viewerOptions: {
      toolbar: true,
      url: "data-source",
    },
    images: [],
    snack: false,
    snackColor: "",
    snackTime: null,
    snackText: "",
    loading: false,
    examen: null,
    validForm: false,
    selectModalidades: [],
    selectPrestaciones: [],
    selectSexos: ["M", "F"],
    selectDateNacPaciente: null,
    menuFechaNac: false,
    fechaNac_paciente: null, //vm.formatDate(new Date().toISOString().substr(0, 10)),
    modalidad: null,
    prestaciones: [],
    modEditPerson: false,
    IDpaciente: null,
    requireRules: [(v) => !!v || "Campo es requerido"],
    rutRules: [
      (v) => !!v || "Rut es requerido",
      (v) => (!!v && validaRut(v)) || "El rut debe ser válido",
    ],
    emailRules: [
      // v => !!v || "Correo es requerido",
      (v) => /.+@.+/.test(v) || !v || "El correo debe ser válido",
    ],
    nombre_paciente: null,
    sexo_paciente: null,
    edad_paciente: null,
    correo_paciente: null,
    selectDateExamen: null,
    menuFechaExa: false,
    fecha_hora_examen: null,
    antecedentes_clinicos: null,
    selectSolicitantes: [],
    medico_solicitante: null,
    dialogApplicant: false,
    editedIndex: -1,
    editedItem: {
      nombre_solicitante: "",
      apellido_solicitante: "",
      correo_solicitante: "",
    },
    defaultItem: {
      nombre_solicitante: "",
      apellido_solicitante: "",
      correo_solicitante: "",
    },
    selectInformantes: [],
    medico_informante: null,
    comentario_tm: null,
    orden_medica: null,
    dcm: [],
    mod: [],
    stl: [],
    ordenSheet: false,
    dropdown_orden: [
      { text: "Archivos", callback: () => console.log("1") },
      { text: "Escanner", callback: () => console.log("2") },
    ],
    open: [],
    fileTypes: {
      orden: "receipt",
      dcm: "texture",
      image: "photo_library",
    },
    tree: [],
    filesExam: {
      orden: [],
      dcm: [],
      otrodcm: [],
      mod: [],
      stl: [],
    },
    DWObject: null,
    haveScann: false,
    haveDWObject: true,
    label_solicitante: window.lang.es.label_solicitante,
    label_informante: window.lang.es.label_informante,
    perfil_medicos: "2, 3",
  }),
  methods: {
    debug() {
      //console.log('medico_solicitante', this.medico_solicitante)
    },
    init() {
      //console.log('INIT')
      /*
        Dynamsoft.WebTwainEnv.DeleteDWTObject("dwtcontrolContainer");
        Dynamsoft.WebTwainEnv.CreateDWTObject(
          "dwtcontrolContainer",
          (newDWObject) => { 
            // console.log('newDWObject', newDWObject)
            this.DWObject = newDWObject; 
            // console.log('DWObject', this.DWObject)
          },
          (errorString) => { console.log('errorString', errorString); }
        );
      */
      Promise.all([
        this.getModalidades(),
        this.getExamen(),
        this.getSolicitantes(),
        this.getInformantes(),
      ])
        .then(() => {
          //console.log('promesa lista', this.$route.name)
          this.initForm();
        })
        .catch((reason) => {
          console.log("Fail", reason);
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada",
            });
          }, 1000);
        });
    },
    initForm() {
      this.modalidad =
        this.selectModalidades.find(
          (el) => el.id_modalidad == this.examen.id_modalidad
        ) || null;
      if (this.modalidad) this.getPrestaciones();
      this.IDpaciente = this.examen.IDPaciente;
      this.nombre_paciente = this.examen.nombre;
      this.sexo_paciente = this.examen.sexo;
      this.selectDate = this.examen.fecha_nacimiento; //new Date(this.examen.fecha_nacimiento).toISOString().substr(0, 10)
      // console.log('fecha_nacimiento',this.examen.fecha_nacimiento)
      this.fechaNac_paciente = this.formatDate(
        new Date(this.examen.fecha_nacimiento).toISOString().substr(0, 10)
      );
      this.edad_paciente = this.examen.edad;
      this.correo_paciente = this.examen.correo_paciente;
      this.fecha_hora_examen = this.formatDate(
        new Date(this.examen.fecha_hora_examen).toISOString().substr(0, 10)
      );
      // console.log('fecha_hora_examen', this.examen.fecha_hora_examen)
      this.antecedentes_clinicos = this.examen.antecedentes_clinicos;
      this.medico_solicitante =
        this.selectSolicitantes.find(
          (el) => el.id_solicitante == this.examen.id_solicitante
        ) || null;
      this.medico_informante =
        this.selectInformantes.find(
          (el) => el.id_usuario == this.examen.id_med_informante
        ) || null;
      this.comentario_tm = this.examen.comentario_TM;

      //this.DWObject = null
      this.haveScann = false;
      this.orden_medica = null;
      this.dcm = [];
      this.mod = [];
      this.stl = [];

      this.filesExam = {
        orden: [],
        dcm: [],
        otrodcm: [],
        mod: [],
        stl: [],
      };

      this.examen.archivos.forEach((file, index) => {
        this.filesExam[file.tipo].push(file);
      });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatRut: formatRut,
    getModalidades() {
      return new Promise((resolve, reject) => {
        configBaseAxios.params = {
          accion: "modalidades",
          opcion: "listarModalidades",
          api_token: this.logged_user.api_token,
        };
        axios
          .create(configBaseAxios)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              // console.log('modalidades', JSON.parse(JSON.stringify(result.data.callback)))
              this.selectModalidades = result.data.callback;
              resolve();
              //this.getExamen(configBaseAxios, this.$route.params.id_examen, logged_user.api_token)
            } else {
              reject("No data result");
              //bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" });
            }
          })
          .catch((error) => {
            reject("Error ajax");
            // console.log(error)
            //bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" });
          });
      });
    },
    getExamen() {
      return new Promise((resolve, reject) => {
        configBaseAxios.params = {
          accion: "examen",
          id_examen: this.$route.params.id_examen,
          api_token: this.logged_user.api_token,
        };
        axios
          .create(configBaseAxios)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              this.examen = result.data.callback;
              //console.log('examen', JSON.parse(JSON.stringify(this.examen)))
              resolve();
            } else {
              reject("No data result");
            }
          })
          .catch((error) => {
            reject("Error ajax");
          });
      });
    },
    getSolicitantes() {
      return new Promise((resolve, reject) => {
        configBaseAxios.params = {
          accion: "solicitantes",
          opcion: "listarSolicitante",
          api_token: this.logged_user.api_token,
        };
        axios
          .create(configBaseAxios)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              //console.log('solicitantes', JSON.parse(JSON.stringify(result.data.callback)))
              this.selectSolicitantes = result.data.callback;
              this.selectSolicitantes.forEach((el) => {
                el.nombre_completo_solicitante =
                  el.nombre_solicitante + " " + el.apellido_solicitante;
              });
              // console.log('selectSolicitantes', JSON.parse(JSON.stringify(this.selectSolicitantes)))
              resolve();
            } else {
              reject("No data result");
            }
          })
          .catch((error) => {
            reject("Error ajax");
          });
      });
    },
    getInformantes() {
      return new Promise((resolve, reject) => {
        configBaseAxios.params = {
          accion: "usuariosPerfiles",
          id_perfil: this.perfil_medicos, // médicos
          api_token: this.logged_user.api_token,
        };
        axios
          .create(configBaseAxios)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              // console.log('informantes', JSON.parse(JSON.stringify(result.data.callback)))
              this.selectInformantes = result.data.callback.map((el) => {
                el.nombre_completo = el.nombres + " " + el.apellidos;
                return el;
              });
              // console.log('selectInformantes', JSON.parse(JSON.stringify(this.selectInformantes)))
              resolve();
            } else {
              reject("No data result");
            }
          })
          .catch((error) => {
            reject("Error ajax");
          });
      });
    },
    getPrestaciones() {
      // console.log('getPrestaciones',JSON.parse(JSON.stringify(this.modalidad)))
      if (this.modalidad) {
        return new Promise((resolve, reject) => {
          configBaseAxios.params = {
            accion: "prestaciones",
            opcion: "listarPrestaciones",
            id_modalidad: this.modalidad.id_modalidad,
            estado: 1,
            api_token: this.logged_user.api_token,
          };
          axios
            .create(configBaseAxios)
            .get(window.base_path + window.ws)
            .then((result) => {
              if (result.data.response) {
                // console.log('select prestaciones', JSON.parse(JSON.stringify(result.data.callback)))
                this.selectPrestaciones = result.data.callback;
                this.prestaciones = this.selectPrestaciones.filter((el) => {
                  return this.examen.prestaciones.some((p) => {
                    return p.id_prestacion == el.id_prestacion;
                  });
                });
                resolve();
              } else {
                reject("No data result");
                //bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" });
              }
            })
            .catch((error) => {
              reject("Error ajax");
              //bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" });
            });
        });
      }
    },
    upOrden(ev) {
      console.log(ev);
    },
    attachImg() {
      console.log("attach image");
      this.$refs.attachmentOrden.click();
      this.ordenSheet = false;
    },
    attachDcm() {
      if (localStorage.uploadingDCM !== "false") {
        alert(
          "No es posible subir más de un archivo DCM de manera simultanea. Por favor espere a que el actual proceso de subida DCM termine."
        );
      } else {
        this.$refs.attachmentDcm.click();
      }
    },
    attachMod() {
      this.$refs.attachmentMod.click();
    },
    attachStl() {
      this.$refs.attachmentStl.click();
    },
    onAttachSelectOrden(attachs) {
      this.orden_medica = this.$refs.attachmentOrden.files[0];
      this.DWObject = null;
      this.haveScann = false;
    },
    onAttachSelectDcm(attachs) {
      let uploadedFiles = this.$refs.attachmentDcm.files;
      if (uploadedFiles.length > 2) {
        alert("No puede subir más de dos archivos DCM.");
      } else {
        this.dcm = [];
        for (var i = 0; i < uploadedFiles.length; i++) {
          if (this.dcm.length == 2 || this.filesExam.otrodcm.length == 2) {
            alert("No puede subir más de dos archivos DCM.");
          } else if (uploadedFiles[i].size < 1073741824) {
            this.dcm.push(uploadedFiles[i]);
          } else {
            alert("Archivo supera tamaño máximo de 1 Gb.");
          }
        }
      }

      // console.log('$refs',this.$refs.attachmentDcm.files)
      // console.log('onAttachSelectDcm', attachs, uploadedFiles,this.dcm)
    },
    onAttachSelectMod(attachs) {
      let uploadedFiles = this.$refs.attachmentMod.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.mod.push(uploadedFiles[i]);
      }
      //console.log('onAttachSelectDcm', attachs, uploadedFiles,this.dcm)
    },
    onAttachSelectStl(attachs) {
      let uploadedFiles = this.$refs.attachmentStl.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.stl.push(uploadedFiles[i]);
      }
      //console.log('onAttachSelectDcm', attachs, uploadedFiles,this.dcm)
    },
    scanImg() {
      //console.log('scanner image')
      // this.loading = true
      // setTimeout(() => {
      this.DWObject = {}; //Dynamsoft.WebTwainEnv.GetWebTwain('dwtcontrolContainer');

      this.orden_medica = null;
      if (this.DWObject) {
        console.log("Si DWObject");
        this.DWObject.Width = 100;
        this.DWObject.Height = 150;
        this.DWObject.IfShowUI = false;
        this.DWObject.IfAppendImage = false;

        if (this.DWObject.SelectSource()) {
          console.log("SelectSource Ok");
        } else {
          console.log("SelectSource Fail");
        }
        this.DWObject.OpenSource();
        this.DWObject.AcquireImage();
        console.log("ErrorCode", this.DWObject.ErrorCode);
      } else {
        console.log("No DWObject");
      }
      // this.loading = false
      this.haveScann = true;
      console.log("haveScann");
      // }, 1000)

      this.ordenSheet = false;
    },
    displayImagesOnPage(successful, mesg, response) {
      //   if(!successful) { // On error
      //     console.error('Failed: ' + mesg);
      //     return;
      //   }
      //   if(successful && mesg != null && mesg.toLowerCase().indexOf('user cancel') >= 0) { // User cancelled.
      //     console.info('User cancelled');
      //     return;
      //   }
      //   var scannedImages = scanner.getScannedImages(response, true, false); // returns an array of ScannedImage
      //   for(var i = 0; (scannedImages instanceof Array) && i < scannedImages.length; i++) {
      //     var scannedImage = scannedImages[i];
      //     processScannedImage(scannedImage);
      //   }
    },
    processScannedImage(scannedImage) {
      //   this.orden_medica.push(scannedImage)
      //   // var elementImg = scanner.createDomElementFromModel( {
      //   //   'name': 'img',
      //   //   'attributes': {
      //   //     'class': 'scanned',
      //   //     'src': scannedImage.src
      //   //   }
      //   // });
      //   // document.getElementById('images').appendChild(elementImg);
    },
    viewImage(images) {
      this.loading = true;
      this.images = images;
      setTimeout(() => {
        this.$refs["viewer"].$viewer.show();
        this.loading = false;
      }, 1000);
    },
    saveExam() {
      return new Promise((resolve, reject) => {
        let formData = new FormData();

        for (var i = 0; i < this.prestaciones.length; i++) {
          let prestacion = this.prestaciones[i];
          formData.append("prestaciones[" + i + "]", prestacion.id_prestacion);
        }

        if (this.orden_medica) {
          formData.append("fileOrden[0]", this.orden_medica);
        }

        /* for( var i = 0; i < this.dcm.length; i++ ){
            let file = this.dcm[i];
            formData.append('fileOtrodcm[' + i + ']', file);
          } */

        for (let i = 0; i < this.mod.length; i++) {
          let file = this.mod[i];
          formData.append("fileMod[" + i + "]", file);
        }

        for (let i = 0; i < this.stl.length; i++) {
          let file = this.stl[i];
          formData.append("fileStl[" + i + "]", file);
        }

        formData.append("accion", "examen");
        formData.append("opcion", "modificar");
        formData.append("id_examen", this.examen.id);
        formData.append("id_estado", this.examen.id_estado);
        formData.append("id_modalidad", this.modalidad.id_modalidad);
        //formData.append('prestaciones', prestaciones)
        formData.append(
          "fecha_hora_examen",
          this.parseDate(this.fecha_hora_examen)
        );
        formData.append(
          "id_solicitante",
          this.medico_solicitante
            ? this.medico_solicitante.id_solicitante
            : null
        );
        formData.append("id_informante", this.medico_informante.id_usuario);
        formData.append("comentario_tm", this.comentario_tm);
        // formData.append('fileOrden', this.orden_medica)
        formData.append("api_token", this.logged_user.api_token);

        var contentData = {
          accion: "examen",
          opcion: "modificar",
          id_examen: this.examen.id,
          id_estado: this.examen.id_estado,
          id_modalidad: this.modalidad.id_modalidad,
          prestaciones: this.prestaciones.map((el) => el.id_prestacion),
          fecha_hora_examen: this.parseDate(this.fecha_hora_examen),
          medico_solicitante: this.medico_solicitante
            ? this.medico_solicitante.id_solicitante
            : null,
          medico_informante: this.medico_informante.id_usuario,
          comentario_tm: this.comentario_tm,
          fileOrden: this.orden_medica,
          api_token: this.logged_user.api_token,
        };
        //console.log('formData', JSON.parse(JSON.stringify(formData)))

        axios({
          method: "post",
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          url: window.base_path + window.ws,
          data: formData,
        })
          .then((result) => {
            //console.log('result modificar examen', contentData, JSON.parse(JSON.stringify(result)))
            if (result.data.response) {
              this.loading = false;
              resolve("Datos del exámen actualizados correctamente");
            } else {
              reject(result.data.message);
            }
          })
          .catch((error) => {
            //console.log('error modificar examen',error)
            reject(error.response);
            // this.snackColor = 'error'
            // this.snackText = error.response
            // this.snack = true
            // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          });
      });
    },
    saveScan() {
      return new Promise((resolve, reject) => {
        // console.log('this.DWObject 1', this.DWObject)
        if (this.DWObject == null) {
          alert("No existe imagen escaneada!");
          return;
        }
        this.DWObject.HTTPPort = 80;

        // this.DWObject.SetViewMode(sHorizontalImageCount, sVerticalImageCount);
        this.DWObject.Width = 100;

        this.DWObject.SetHTTPFormField("id_examen", this.examen.id);
        this.DWObject.SetHTTPFormField("accion", "examen");
        this.DWObject.SetHTTPFormField("api_token", this.logged_user.api_token);
        this.DWObject.SetHTTPFormField("opcion", "modificarOrden");

        if (
          this.DWObject.GetImageBitDepth(
            this.DWObject.CurrentImageIndexInBuffer
          ) == 1
        ) {
          //If so, convert the image to Gray
          this.DWObject.ConvertToGrayScale(
            this.DWObject.CurrentImageIndexInBuffer
          );
        }

        this.DWObject.HTTPUploadThroughPost(
          window.base_path,
          this.DWObject.CurrentImageIndexInBuffer,
          window.ws,
          "orden_scan.jpg",
          onSuccessUpload,
          onErrotUpload
        );
        function onSuccessUpload(data1, data2, data3) {
          console.log("success", data1, data2, data3);
          resolve("Orden almacenada correctamente.");
        }
        function onErrotUpload(data1, data2, data3) {
          console.log("error", data1, data2, data3);
          reject(this.DWObject.ErrorString);
        }
        // if (this.DWObject.ErrorCode != 0) {
        //   reject(error.response)
        //   // alert(this.DWObject.ErrorString);
        // } else {
        //   // alert("Image Uploaded successfully");
        //   resolve('Datos del exámen actualizados correctamente.')
        // }
        // console.log('this.DWObject 2', this.DWObject)
      });
    },
    savePatient() {
      return new Promise((resolve, reject) => {
        /* 
            $_REQUEST['IDpaciente']
            $_REQUEST['rutPaciente']
            $_REQUEST['nombrePaciente']
            $_REQUEST['sexoPaciente']
            $_REQUEST['fechaNacimiento']
            $_REQUEST['antecedentesClinicos']
            $_REQUEST['correoPaciente']
          */
        var contentData = {
          accion: "pacientes",
          opcion: "editarPaciente",
          id_paciente: this.examen.id_paciente,
          rutPaciente: this.IDpaciente,
          nombrePaciente: this.nombre_paciente,
          sexoPaciente: this.sexo_paciente,
          fechaNacimiento: moment(this.parseDate(this.fechaNac_paciente))
            .format()
            .substr(0, 10),
          antecedentesClinicos: this.antecedentes_clinicos,
          correoPaciente: this.correo_paciente,
          api_token: this.logged_user.api_token,
        };

        axios({
          method: "post",
          withCredentials: true,
          url: window.base_path + window.ws,
          data: contentData,
        })
          .then((result) => {
            // console.log('result editarPaciente', contentData, JSON.parse(JSON.stringify(result)))
            if (result.data.response) {
              resolve("Datos del paciente actualizados correctamente.");
            } else {
              reject(result.data.message);
            }
          })
          .catch((error) => {
            // console.log('error',error)
            reject(error.response);
            // this.snackColor = 'error'
            // this.snackText = error.response
            // this.snack = true
            // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          });
      });
    },
    saveDcm() {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        for (var i = 0; i < this.dcm.length; i++) {
          let file = this.dcm[i];
          formData.append("fileOtrodcm[" + i + "]", file);
        }
        formData.append("accion", "examen");
        formData.append("opcion", "agregaDcm");
        formData.append("id_examen", this.examen.id);
        formData.append("api_token", this.logged_user.api_token);

        bus.$emit("tradeDCM", {
          status: "start",
          text: "Subiendo DCM para paciente: " + this.IDpaciente,
          color: "loaddcm",
        });

        axios({
          method: "post",
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          url: window.base_path + window.ws,
          data: formData,
        })
          .then((result) => {
            //console.log('result modificar examen', contentData, JSON.parse(JSON.stringify(result)))
            if (result.data.response) {
              bus.$emit("tradeDCM", {
                status: "success",
                text: "Completada subida DCM para paciente: " + this.IDpaciente,
                color: "green",
              });
              resolve("DCM del exámen actualizado correctamente");
            } else {
              bus.$emit("tradeDCM", {
                status: "error",
                text:
                  "Error al intentar subir DCM para paciente: " +
                  this.IDpaciente,
                color: "error",
              });
              reject(result.data.message);
            }
          })
          .catch((error) => {
            //console.log('error modificar examen',error)
            bus.$emit("tradeDCM", {
              status: "error",
              text:
                "Error al intentar subir DCM para paciente: " + this.IDpaciente,
              color: "error",
            });
            reject(error.response);
            // this.snackColor = 'error'
            // this.snackText = error.response
            // this.snack = true
            // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          });
      });
    },
    saveData() {
      if (this.$refs.formExam.validate()) {
        if (this.prestaciones.length === 0) {
          alert("No ha seleccionado prestaciones para esta modalidad.");
          return false;
        }

        this.loading = true;

        let observable = [this.saveExam()];

        if (this.haveScann) {
          observable.push(this.saveScan());
        }

        if (this.modEditPerson) {
          observable.push(this.savePatient());
        }

        if (this.dcm.length > 0) {
          if (localStorage.uploadingDCM !== "false") {
            alert(
              "No es posible subir más de un archivo DCM de manera simultanea. Por favor espere a que el actual proceso de subida DCM termine."
            );
          } else {
            observable.push(this.saveDcm());
          }
        }

        Promise.all(observable)
          .then((message) => {
            //console.log('Done', message)
            this.snackColor = "success";
            this.snackText = message.join(" Y "); //'Examen almacenado correctamente'//message
            this.snack = true;

            if (this.$route.name === "ExamEdit") {
              this.init();
            } else if (this.$route.name === "Exams") {
              this.initialize();
            }

            /* if (!confirm('¿Desea continuar editando este exámen?')) {
              this.$router.push({name: 'Exams'})
            } else {
              this.init()
            } */
          })
          .catch((reason) => {
            // console.log('Fail', reason)
            this.snackColor = "error";
            this.snackText = reason;
            this.snack = true;
            // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          })
          .then(() => {
            this.loading = false;
          });
      }
    },
    downloadFile(file) {
      window.open(file.url, "Descargando...");
    },
    deleteFile(file) {
      if (confirm("Seguro desea eliminar permanentemente este archivo?")) {
        //console.log('delete', file)
        var contentData = {
          accion: "archivos",
          opcion: "borrarArchivo",
          id_archivo: file.id_archivo,
          api_token: this.logged_user.api_token,
        };

        axios({
          method: "post",
          withCredentials: true,
          url: window.base_path + window.ws,
          data: contentData,
        })
          .then((result) => {
            //console.log('result delete', contentData, JSON.parse(JSON.stringify(result)))
            if (result.data.response) {
              // resolve('Datos del paciente actualizados correctamente.')
              this.snackColor = "success";
              this.init();
            } else {
              // reject(result.data.message)
              this.snackColor = "error";
            }
            this.snackText = result.data.mensaje;
            this.snack = true;
          })
          .catch((error) => {
            // console.log('error',error)
            // reject(error.response)
            this.snackColor = "error";
            this.snackText = error.response;
            this.snack = true;
            // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          });
      }
    },
    closeApplicant(el) {
      this.dialogApplicant = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.formApplicant.reset();
      }, 300);
    },
    saveApplicant(el) {
      if (this.$refs.formApplicant.validate()) {
        const contentData = {
          accion: "solicitantes",
          opcion:
            this.editedIndex > -1 ? "editarSolicitante" : "nuevoSolicitante",
          id_solicitante:
            this.editedIndex > -1 ? this.editedItem.id_solicitante : null,
          nombreSolicitante: this.editedItem.nombre_solicitante,
          apellidoSolicitante: this.editedItem.apellido_solicitante,
          correoSolicitante: this.editedItem.correo_solicitante,
          estado: 1,
          api_token: this.logged_user.api_token,
        };

        // console.log('contentData', JSON.parse(JSON.stringify(contentData)))

        axios({
          method: "post",
          withCredentials: true,
          url: window.base_path + window.ws,
          data: contentData,
        })
          .then((result) => {
            // console.log('result modificar examen', contentData, JSON.parse(JSON.stringify(result)))
            this.snackText = result.data.mensaje;
            if (result.data.response) {
              this.snackColor = "success";
              if (this.editedIndex > -1) {
                // Object.assign(this.desserts[this.editedIndex], this.editedItem)
              } else {
                this.editedItem.id_solicitante = result.data.id_solicitante;
                // this.desserts.push(this.editedItem)
                this.getSolicitantes().then(
                  (resolve) => {
                    // console.log('resolve ok', resolve, this.editedItem, this.editedItem.id_solicitante)
                    this.medico_solicitante =
                      this.selectSolicitantes.find(
                        (el) =>
                          el.id_solicitante == this.editedItem.id_solicitante
                      ) || null;
                  },
                  (error) => {
                    console.log("Error", error);
                  }
                );
              }
            } else {
              this.snackColor = "error";
            }
            this.snack = true;
          })
          .catch((error) => {
            // console.log('error',error)
            this.snackColor = "error";
            this.snackText = error.response;
            this.snack = true;
            setTimeout(() => {
              bus.$emit("userStatus", {
                isLogged: false,
                message: "Sesión de usuario finalizada",
              });
            }, 1000);
          })
          .finally(() => {
            this.closeApplicant();
          });
      }
    },
  },
  watch: {
    selectDateNacPaciente(val) {
      this.fechaNac_paciente = this.formatDate(this.selectDateNacPaciente);
      this.edad_paciente = moment().diff(this.selectDateNacPaciente, "years");
    },
    selectDateExamen(val) {
      this.fecha_hora_examen = this.formatDate(this.selectDateExamen);
    },
    modEditPerson(val) {
      if (!this.modEditPerson) {
        //alert("")
        this.snackColor = "amber darken-4";
        this.snackTime = 5000;
        this.snackText =
          "Al deshabilitar la edición de los datos del paciente, cualquier cambio efectuado no será modificado";
        this.snack = true;
      }
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nuevo Odontólogo"
        : "Editar Odontólogo";
    },
    correo_solicitante() {
      return this.medico_solicitante
        ? this.medico_solicitante.correo_solicitante
          ? this.medico_solicitante.correo_solicitante
          : "sin correo"
        : "...@...";
    },
    dcms() {
      return this.dcm
        .map((el) => {
          let large = el.name.length;
          let ext = el.name.split(".").pop();
          return large > 14 ? el.name.substr(0, 10) + "(...)." + ext : el.name;
        })
        .join(", ");
    },
    mods() {
      return this.mod
        .map((el) => {
          let large = el.name.length;
          let ext = el.name.split(".").pop();
          return large > 14 ? el.name.substr(0, 10) + "(...)." + ext : el.name;
        })
        .join(", ");
    },
    stls() {
      return this.stl
        .map((el) => {
          let large = el.name.length;
          let ext = el.name.split(".").pop();
          return large > 14 ? el.name.substr(0, 10) + "(...)." + ext : el.name;
        })
        .join(", ");
    },
  },
};
</script>
